import React, {Component} from 'react';
import {EditClientAdAccountModal} from "./EditClientAdAccountModal";
import {FaIcon} from "../../FaIcon";

export class EditClientAdAccountModalButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.handleSuccessfulEdited = this.handleSuccessfulEdited.bind(this);
    }

    handleSuccessfulEdited(clientAdAccountId) {
        this.props.onClientAdAccountEdited();
    }

    render() {
        const iconName = this.props.iconName || "pencil-alt";
        const buttonClassName = this.props.buttonClassName || "edit-button";
        const title = this.props.title || this.props['aria-label'];

        return (
            <span>
                <button type="button" className={buttonClassName} title={title} aria-label={this.props['aria-label'] || title} onClick={(event) => {
                    event.stopPropagation();
                    this.editClientAdAccountModal.toggle()
                }}><FaIcon iconName={iconName}/></button>
                <EditClientAdAccountModal ref={instance => {this.editClientAdAccountModal = instance;}}
                                          afterSuccessfulEdited={this.handleSuccessfulEdited}
                                          clientAdAccount={this.props.clientAdAccount}
                                          clientId={this.props.clientId}
                                          clientName={this.props.clientName}

                />
            </span>
        );
    }
}
